import { Box, Container, Typography, Link } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: (t) => t.spacing(3),
        px: (t) => t.spacing(2),
        mt: "auto",
        color: "text.secondary",
        borderTop: 1,
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="body2" align="center">
          Built with{" "}
          <Link
            href="https://solidproject.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Solid
          </Link>{" "}
          &{" "}
          <Link
            href="https://threejs.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Three.js
          </Link>
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
